
export default {
  props: {
    stroke: {
      type: String,
      default: '#000000',
    },
  },
}
